import Component from '../abstracts/Component';
import ClipboardJS from 'clipboard';


export default class SmallInfoPushComponent extends Component {

  get SELECTORS() {
    return {
      button: '.js-copy-code'
    };
  }

  get CLASSES() {
    return {
      show: 'show'
    };
  }

  constructor() {
    super();
  }

  bindEvents() {

    let _this = this;

    $(this.SELECTORS.button).on('click', function (e) {
      e.preventDefault();
      _this.log('promo code copied!');
      let btn = $(e.currentTarget);
      let prevText = btn.children().text();
      btn.children().fadeOut(250, () => {
        btn.children().text(btn.attr('data-copied-notify'));
        btn.children().fadeIn(250);
        setTimeout(()=>{
          btn.children().fadeOut(250, () =>{
            btn.children().text(prevText);
            btn.children().fadeIn(250);
          });
        }, 1500)
      });
    });

    let clipboard = new ClipboardJS(this.SELECTORS.button);
    /*
    clipboard.on('success', function (e) {
      console.log(e);
    });
    clipboard.on('error', function (e) {
      console.log(e);
    })*/


  }

  render() {
    this.bindEvents();
  }
}
